import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

export default function NTNavbar() {
  const [scrolled, setScrolled] =
    useState(false);

  const [mobileOpen, setMobileOpen] =
    useState(false);

  const location = useLocation();

  const ntNavLinks = [
    { label: "Home", href: "/" },
    { label: "Sobre", href: "/sobre" },
    { label: "Serviços", href: "/servicos" },
    { label: "Produtos", href: "/produtos" },
    { label: "Contato", href: "/contato" },
  ];

  useEffect(() => {
    const handleScroll = () =>
      setScrolled(window.scrollY > 60);

    window.addEventListener(
      "scroll",
      handleScroll
    );

    return () =>
      window.removeEventListener(
        "scroll",
        handleScroll
      );
  }, []);

  return (
    <header className="fixed top-0 left-0 w-full z-50 bg-white shadow-sm">
      <div
        className={`bg-[#1B1F5E] transition-all duration-300 ${
          scrolled
            ? "h-0 overflow-hidden py-0"
            : "py-4"
        }`}
      >
        <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
          <a
            href="tel:+554797740084"
            className="flex items-center gap-2 text-white text-xs hover:text-[#3FA7D6] transition-colors cursor-pointer"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-phone-line text-xs"></i>
            </div>

            +55 (47) 9774-0084
          </a>

          <div className="flex items-center gap-4">
            <a
              href="mailto:contato@newtechsolution.com.br"
              className="text-white/70 text-xs hover:text-[#3FA7D6] transition-colors cursor-pointer hidden sm:block"
            >
              contato@newtechsolution.com.br
            </a>

            <div className="flex items-center gap-3">
              {[
                "ri-instagram-line",
                "ri-linkedin-line",
                "ri-youtube-line",
                "ri-facebook-line",
              ].map((icon) => (
                <a
                  key={icon}
                  href="#"
                  className="w-5 h-5 flex items-center justify-center text-white hover:text-[#3FA7D6] transition-colors cursor-pointer"
                >
                  <i
                    className={`${icon} text-sm`}
                  ></i>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>

      <nav className="border-b border-gray-100 bg-white">
        <div className="max-w-7xl mx-auto px-6 h-[88px] flex items-center justify-between">
          <Link
            to="/"
            className="flex items-center cursor-pointer shrink-0"
          >
            <img
              src="https://i.ibb.co/kVfj2bGb/foto-alta-qualidade.png"
              alt="New Tech Solution"
              className="h-14 w-auto object-contain"
            />
          </Link>

          <ul className="hidden md:flex items-center gap-2">
            {ntNavLinks.map((link) => (
              <li key={link.label}>
                <Link
                  to={link.href}
                  className={`px-3 py-2 text-base font-medium transition-colors cursor-pointer whitespace-nowrap ${
                    location.pathname ===
                    link.href
                      ? "text-[#1B1F5E]"
                      : "text-[#333] hover:text-[#1B1F5E]"
                  }`}
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>

          <div className="flex items-center gap-3">
            <Link
              to="/contato"
              className="hidden md:flex items-center gap-2 bg-[#1B1F5E] hover:bg-[#2F4F8F] text-white font-bold text-sm px-6 h-[46px] rounded-md transition-colors cursor-pointer whitespace-nowrap"
            >
              Solicitar Orçamento
            </Link>

            <button
              className="md:hidden w-10 h-10 flex items-center justify-center text-[#333] cursor-pointer"
              onClick={() =>
                setMobileOpen(
                  !mobileOpen
                )
              }
            >
              <i
                className={`${
                  mobileOpen
                    ? "ri-close-line"
                    : "ri-menu-line"
                } text-2xl`}
              ></i>
            </button>
          </div>
        </div>

        {mobileOpen && (
          <div className="md:hidden bg-white border-t border-gray-100 px-6 py-4">
            <ul className="flex flex-col gap-3">
              {ntNavLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="block text-sm font-medium text-[#333] hover:text-[#1B1F5E] transition-colors cursor-pointer py-2"
                    onClick={() =>
                      setMobileOpen(
                        false
                      )
                    }
                  >
                    {link.label}
                  </Link>
                </li>
              ))}

              <li>
                <Link
                  to="/contato"
                  className="block text-center bg-[#1B1F5E] text-white font-bold text-sm px-5 py-3 rounded-md cursor-pointer mt-2"
                  onClick={() =>
                    setMobileOpen(
                      false
                    )
                  }
                >
                  Solicitar Orçamento
                </Link>
              </li>
            </ul>
          </div>
        )}
      </nav>
    </header>
  );
}
